// extracted by mini-css-extract-plugin
module.exports = {"salty":"CardSalt_salty__yaKwo","saltyTooltip":"CardSalt_saltyTooltip__9zBpy"};